import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ActivityItemTypeService from "../../../Domain/ActivityItemType/ActivityItemType.service";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import useParams from "../../Hooks/useParams";
import TaskService, { editFormStateToUpdateTaskTaskArgType, } from "../../../Services/Task.service";
import useService from "../../Hooks/useService";
import UpdateFeed from "../../Presentational/ItemUpdate/UpdateFeed";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import SecondaryNavButton from "../../UI/SecondaryNav/SecondaryNavButton";
import useHasPermission from "../../Hooks/useHasPermission";
import TaskInfo from "../../Presentational/Task/TaskInfo";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import TaskUpdateForm from "../../Presentational/Task/TaskUpdateForm";
import TaskEditForm from "../../Presentational/Task/TaskEditForm";
import PersonService from "../../../Services/Person.service";
import RoleService from "../../../Services/Role.service";
const TaskShow = () => {
    const taskId = parseInt(useParams().taskId, 10);
    const [taskState, loadTask, taskActions] = useService(TaskService.getTask);
    React.useEffect(() => {
        loadTask(taskId);
    }, [loadTask, taskId]);
    const canEditTasks = useHasPermission("CAN_EDIT_TASKS");
    const [meState, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    /* TODO: TEMPORARY, permissions don't allow students to access the searchEndpoints api, this makes the feed display
         an error for students on this page. Below service call checks if current user is staff to determine whether
          or not to show feed in this component */
    const [isStaff, loadIsStaff] = useService(RoleService.currentUserIsStaff);
    React.useEffect(() => {
        loadIsStaff();
    }, [loadIsStaff]);
    const [isUpdateTaskModalOpen, setIsUpdateTaskModalOpen] = React.useState(false);
    const [isEditTaskModalOpen, setIsEditTaskModalOpen] = React.useState(false);
    const search = React.useMemo(() => ({
        global: {
            items: [
                {
                    itemIdInt: taskId,
                    activityItemTypeId: ActivityItemTypeService.TaskId,
                },
            ],
            activityItemTypeIds: [ActivityItemTypeService.TaskId],
        },
        latestValue: [],
    }), [taskId]);
    return (_jsx(SecondaryNavLayout, { nav: _jsx("div", { className: "d-flex justify-content-between w-100 align-items-center", children: _jsxs("div", { className: "d-flex", children: [_jsx(SecondaryNavButton, { icon: "fal fa-caret-square-up", label: "Update", onClick: () => setIsUpdateTaskModalOpen(true) }), canEditTasks && (_jsx(SecondaryNavButton, { icon: "fal fa-pencil-alt", label: "Edit", onClick: () => setIsEditTaskModalOpen(true) }))] }) }), children: _jsx("div", { className: "container-fluid mt-4", children: _jsx(ServiceResult, { state: taskState, children: (task) => (_jsxs(_Fragment, { children: [_jsx(TaskInfo, { task: task }), isStaff.wasSuccessful && isStaff.data && (_jsx("div", { className: "mt-4", children: _jsx(UpdateFeed, { hideItemUpdatePaths: true, hideFormattedText: true, search: search, pageSize: 5, commentContext: {
                                    activityItemTypeId: ActivityItemTypeService.TaskId,
                                    id: taskId,
                                } }) })), _jsx(ModalFormFormat, { isOpen: isUpdateTaskModalOpen, onModalClosed: () => setIsUpdateTaskModalOpen(false), defaultValue: { status: task.status }, handleSubmit: (form) => {
                                var _a;
                                return TaskService.updateTaskStatus(task.id, form.status.id, {
                                    notifyPersonIds: (_a = form.peopleToNotify) === null || _a === void 0 ? void 0 : _a.map((person) => person.personId),
                                    comment: form.comment,
                                }).then(() => {
                                    taskActions.edit(Object.assign(Object.assign({}, task), { status: form.status }));
                                });
                            }, modalTitle: "Update Task", children: (formVals) => (_jsx(TaskUpdateForm, Object.assign({}, formVals, { oldTaskStatusId: task.status.id }))) }), _jsx(ModalFormFormat
                        // @ts-expect-error - TS2352 - Conversion of type 'Task' to type 'TaskEditFormState' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
                        , { 
                            // @ts-expect-error - TS2352 - Conversion of type 'Task' to type 'TaskEditFormState' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
                            defaultValue: task, modalTitle: "Edit Task", size: "xl", isOpen: isEditTaskModalOpen, onModalClosed: () => setIsEditTaskModalOpen(false), handleSubmit: (form) => {
                                var _a;
                                return TaskService.updateTask(editFormStateToUpdateTaskTaskArgType(task.id, form), {
                                    peopleToNotify: (_a = form.peopleToNotify) === null || _a === void 0 ? void 0 : _a.map((person) => person.personId),
                                    comment: form.comment,
                                }).then((newTask) => {
                                    taskActions.edit(newTask);
                                });
                            }, children: (formVals) => (_jsx(ServiceResult, { state: meState, children: (me) => (_jsx(TaskEditForm, Object.assign({}, formVals, { taskIsPrivate: task.isPrivate, taskIsInActionPlan: !!task.actionPlanTitle, currentUser: me }))) })) })] })) }) }) }));
};
export default TaskShow;
